import * as Yup from 'yup';

const newRegistro = {
    userCode: '',
    name: '',
    email: '',
    whatsApp: '',
    active: true,
    perfil: '',
    lastAccessDate: null,
};

const newFilter = {
    active: '',
    name: '',
    email: '',
    whatsapp: '',
    perfil: '',
    rows: 10,
    page: 0,
    where: ''
};

const validation = Yup.object().shape({
    name: Yup.string()
        .required('Este campo é obrigatório')
        .max(100, 'Nome deve ter menos do que 100 caracteres'),
    email: Yup.string()
        .email('Email inválido')
        .required('Este campo é obrigatório')
        .max(100, 'Email deve ter menos do que 100 caracteres'),
    whatsApp: Yup.string()
        .matches(/^[\d\s\(\)\-]*$/, 'WhatsApp deve conter apenas números')
        .max(15, 'WhatsApp deve ter menos do que 15 caracteres'),
    active: Yup.boolean()
        .required('Este campo é obrigatório'),
    perfil: Yup.string()
        .required('Este campo é obrigatório'),
});

const filterValidation = Yup.object().shape({
    active: Yup.string().nullable(),
    name: Yup.string().max(100, 'Nome muito longo'),
    email: Yup.string().email('Email inválido').max(100, 'Email muito longo'),
    whatsapp: Yup.string().matches(/^[\d\s\(\)\-]*$/, 'WhatsApp deve conter apenas números'),
    perfil: Yup.string().nullable(),
});

export const usuarioCadastro = {
    newRegistro,
    newFilter,
    validation,
    filterValidation
};